import * as colorsOld from "material-ui-effco/styles/colors"
import { createMuiTheme } from "material-ui/styles"
// import { blueGrey, amber } from 'material-ui/colors'
import getMuiTheme from "material-ui-effco/styles/getMuiTheme"

import * as customColors from "./styles/colors"

export const API_URL = process.env.REACT_APP_API_URL

export const DATE_FORMAT = "DD/MM/YYYY"

// Material UI palette
export const newTheme = createMuiTheme({
  palette: {
    primary: {
      500: "#235378",
      // ...deepOrange,
      // 500:
      //   process.env.REACT_APP_ENV === 'production'
      //     ? amber[900]
      //     : bimbleLightBlue
    },
    secondary: customColors.bimbleGrey,
    alternative: {
      ...customColors.bimbleLightBlue,
      main: customColors.bimbleLightBlue[500],
    },
  },
  overrides: {
    MuiInput: {
      root: {
        background: "#eee",
      },
      input: {
        padding: "5px",
        fontSize: "0.8rem",
        "&:focus": {
          borderColor: "#80bdff",
          boxShadow: "inset 0 0 0 0.2rem rgba(0,123,255,.25)",
        },
        "&:disabled": {
          borderColor: "#eee",
        },
      },
      underline: {
        "&:hover:not($disabled):before": {
          backgroundColor: "#eee",
          height: "0.01px",
        },
        "&:after": {
          height: "0px",
        },
        "&:before": {
          height: "0px",
        },
      },
      formControl: {
        marginTop: "20px !important",
      },
      multiline: {
        paddingTop: "0px !important",
      },
    },
    MuiTextarea: {
      textarea: {
        height: "calc(100% + 8px)",
      },
    },
    MuiInputLabel: {
      root: {
        fontSize: "1.1rem", //'0.6rem',
        color: "#000",
        fontWeight: "bold",
      },
    },
    MuiListItem: {
      root: {
        fontSize: "0.78rem !important",
      },
    },
    MuiIconButton: {
      icon: {
        width: "1rem !important",
        height: "1rem !important",
      },
    },
  },
})

export const oldTheme = getMuiTheme({
  palette: {
    primary1Color:
      process.env.REACT_APP_ENV === "production"
        ? customColors.bimbleDarkBlue[500]
        : customColors.bimbleDarkBlue[500],
    primary2Color:
      process.env.REACT_APP_ENV === "production"
        ? customColors.bimbleDarkBlue[500] //colorsOld.white
        : customColors.bimbleDarkBlue[500], // colorsOld.white,
    primary3Color:
      process.env.REACT_APP_ENV === "production"
        ? customColors.bimbleGrey[700]
        : customColors.bimbleGrey[700],
    accent1Color:
      process.env.REACT_APP_ENV === "production"
        ? customColors.bimbleGrey[500]
        : customColors.bimbleGrey[500],
    accent2Color:
      process.env.REACT_APP_ENV === "production"
        ? customColors.bimbleGrey[100]
        : customColors.bimbleGrey[100],
    accent3Color:
      process.env.REACT_APP_ENV === "production"
        ? customColors.bimbleGrey[700]
        : customColors.bimbleGrey[700],
    textColor: colorsOld.darkBlack,
    alternateTextColor: colorsOld.white,
    canvasColor: colorsOld.white,
    borderColor: colorsOld.grey300,
    pickerHeaderColor: colorsOld.lightBlue100,
    disabledColor: colorsOld.grey700,
  },
})



// WEBPACK FOOTER //
// ./src/core/constants.js